export default __webpack_public_path__ + "svg/calendar/2026/4/mayo.svg?72c235a8";